console.info("A museum website by brik.digital");
console.info("theme: depont");

import '../css/app.css';

/* Components */
import "./vendor/datastar-pro";
import './components/alpine.js';
import './components/vidstack.js';

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

import 'lazysizes';

const main = async () => {
    return null;
};

const sliders =()=>{
    let sliders = document.querySelectorAll('[data-swiper]');

    sliders.forEach((slider, index) => {
        let slides = slider.querySelectorAll('.swiper-slide');
        let sliderData = JSON.parse(slider.dataset.swiper);

        let defaultOptions = {
            slidesPerView: 5,
            spaceBetween: 12,
            initialSlide: 0,
            grabCursor: true,
            centeredSlides: false,
            loop: true,
            navigation: {
                nextEl: "button-next",
                prevEl: "button-prev",
                disabledClass: 'opacity-50',
            },
        }

        let typeOptions = {};
        switch(sliderData.type) {
          
            case "card":
              typeOptions = {
                centeredSlides: false,
                loop: false,
                spaceBetween: 20,
                slidesPerView: 1.2,
                navigation: {
                    nextEl: '.button-next',
                    prevEl: '.button-prev',
                    disabledClass: 'opacity-50',
                },
                mousewheel: {
                  enabled: true,
                  forceToAxis: true,
                },
                breakpoints: {
                  768: {
                    slidesPerView: 1.3,
                  },
                  1024: {
                    slidesPerView: 2.6,
                  },
                  1280: {
                    slidesPerView: 3,
                  },
                  1440: {
                    slidesPerView: 3,
                  },
                  1600: {
                    slidesPerView: 3,
                  },
                },
              };
            break;
            case "images":
              typeOptions = {
                centeredSlides: false,
                loop: false,
                spaceBetween: 16,
                slidesPerView: 'auto',
                navigation: {
                    nextEl: '.button-next',
                    prevEl: '.button-prev',
                    disabledClass: 'opacity-50',
                },
                mousewheel: {
                  enabled: true,
                  forceToAxis: true,
                },
              };
            break;
            case "collectionItem":
              typeOptions = {
                centeredSlides: false,
                loop: false,
                spaceBetween: 20,
                slidesPerView: 1,
                autoHeight: true,
                navigation: {
                    nextEl: '.button-next',
                    prevEl: '.button-prev',
                    disabledClass: 'opacity-30',
                },
                mousewheel: {
                  enabled: true,
                  forceToAxis: true,
                },
              };
            break;

        }

        let options = {
            ...{
                ...defaultOptions,
                ...typeOptions
            },
            ...sliderData
        };

        if (slides.length <= sliderData.minSlides) {
            options = {
                ...options,
                ...{
                    loop: false,
                    centeredSlides: false,
                }
            }
        }

        const swiper = new Swiper(slider, options);
    });
}

const videos =()=>{
    let videos = document.querySelectorAll('[data-video]');

    videos.forEach((video, index) => {
        VidstackPlayer.create({
          target: video,
          layout: new PlyrLayout({
            controls: [
              'play-large'
            ],
            clickToPlay: true,
            hideControlsOnMouseLeave: true,
          }),
        });
    });
}

main().then( (root) => {
    sliders();
    videos();
});

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR")
  });
}